import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from 'react';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '../lib/browserStorage';

const LOCAL_STORAGE_KEY = 'app-design-choice';

const DesignContext = createContext({
  designStyle: 'classic',
  toggleDesignStyle: () => {},
});

export function DesignProvider({ children }) {
  const [designStyle, setDesignStyle] = useState(() => {
    const saved = getLocalStorageItem(LOCAL_STORAGE_KEY);
    return saved === 'premium' ? 'premium' : 'classic';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-design', designStyle);
    setLocalStorageItem(LOCAL_STORAGE_KEY, designStyle);
  }, [designStyle]);

  const toggleDesignStyle = useCallback(() => {
    setDesignStyle((prev) => (prev === 'classic' ? 'premium' : 'classic'));
  }, []);

  const value = useMemo(
    () => ({
      designStyle,
      toggleDesignStyle,
    }),
    [designStyle, toggleDesignStyle]
  );

  return (
    <DesignContext.Provider value={value}>{children}</DesignContext.Provider>
  );
}

export const useDesign = () => useContext(DesignContext);
export default DesignContext;
